import { useCallback, useEffect, useMemo } from "react";
import { useController as useDataTable } from "@/composites/data-table/hooks/use-controller";
import { DataTableControllerStoreType } from "@/composites/data-table/index";
import { useSystemViewService } from "@/services";
import { SystemViewUserItemType } from "@/schemas/index";

type SystemViewFilterType = {
  query?: string;
};

export const useTable = () => {
  const { fetchSystemUserList } = useSystemViewService();

  const fetchLoadData = useCallback(
    async ({
      pagination,
      filterValue,
    }: DataTableControllerStoreType<
      SystemViewUserItemType,
      SystemViewFilterType
    >): Promise<
      DataTableControllerStoreType<SystemViewUserItemType, SystemViewFilterType>
    > => {
      const queryValue = filterValue?.query?.trim() || "";

      if (!queryValue) {
        return {
          initial: true,
          dataSource: [],
          pagination: {
            ...pagination,
            total: 0,
          },
        };
      }

      const userList = await fetchSystemUserList(queryValue);

      return {
        initial: true,
        dataSource: userList,
        pagination: {
          ...pagination,
          total: userList?.length || 0,
        },
      };
    },
    [fetchSystemUserList],
  );

  const controllerDataTable = useDataTable<
    SystemViewUserItemType,
    SystemViewFilterType
  >("system-view-table");

  useEffect(() => {
    controllerDataTable.setLoadData(fetchLoadData);
  }, [fetchLoadData]);

  useEffect(() => {
    if (
      controllerDataTable?.initial === false &&
      controllerDataTable?.loadData
    ) {
      controllerDataTable.loadData();
    }
  }, [controllerDataTable?.loadData]);

  return useMemo(() => controllerDataTable, [controllerDataTable]);
};
